import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { corporateCMSApi, post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { fieldsReady } from "../constants";
import { useLatestNewsList } from "../TraningAcademy.hook";

export const AddEditTrainingAcademyNews = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [fieldData, setFieldData] = useState<any>();
  const [parentId, setParentId] = useState<any>();
  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useLatestNewsList(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);
  const getRecords = () => {
    let url = `/api/airport-academy/latest-news/all-fields`;
    corporateCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setParentId(envelopes?.[0]?.parent_id);
        }
      })
      .catch((err) => {
        setParentId("");
      });
  };
  useEffect(() => {
    getRecords();
  }, []);

  async function fetchData() {
    try {
      const resolvedFields = await fieldsReady();
      console.log("fieldsReady", resolvedFields);
      setFieldData(resolvedFields);
    } catch (error) {
      console.error("Error fetching fields:", error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const NewsFormConfig: FormConfig = {
    initialValues: {
      published: dataById
        ? decodeHTML(dataById.payload?.published)
        : editData
          ? decodeHTML(editData?.[0]?.published)
          : false,
      field_latest_news_date: dataById
        ? decodeHTML(dataById.payload?.field_latest_news_date)
        : editData
          ? decodeHTML(editData?.[0]?.field_latest_news_date)
          : "",
      field_description: dataById
        ? decodeHTML(dataById.payload?.field_description)
        : editData
          ? decodeHTML(editData?.[0]?.field_description)
          : "",
      field_description_ms: dataById
        ? decodeHTML(dataById.payload?.field_description_ms)
        : editData
          ? decodeHTML(editData?.[0]?.field_description_ms)
          : "",
      field_description_zhans: dataById
        ? decodeHTML(dataById.payload?.field_description_zhans)
        : editData
          ? decodeHTML(editData?.[0]?.field_description_zhans)
          : "",
      field_img: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_img.png",
              status: "done",
              url: dataById?.payload?.field_img,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_img.png",
              status: "done",
              url: editData?.[0]?.field_img,
            },
          ]),
      field_header: dataById
        ? decodeHTML(dataById.payload.field_header)
        : editData
          ? decodeHTML(editData?.[0]?.field_header)
          : "",
      field_header_ms: dataById
        ? decodeHTML(dataById.payload.field_header_ms)
        : editData
          ? decodeHTML(editData?.[0]?.field_header_ms)
          : "",
      field_header_zhans: dataById
        ? decodeHTML(dataById.payload.field_header_zhans)
        : editData
          ? decodeHTML(editData?.[0]?.field_header_zhans)
          : "",
    },
    fields: fieldData?.latestNewsList || [],
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["field_img"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    const payload = {
      action: action,
      method: method,
      module: "Malaysia Airport Academy",
      subModule: "news_latestNewsList",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Malaysia Airport Academy_News",
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
        parent_id: editData?.[0]?.parent_id || dataById?.payload?.parent_id || parentId,
      },
      status: status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status === "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          navigate(`/dedicated/status-information?activeTab=${status === "PENDING" ? "pending" : "draft"}`);
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status === "DRAFT" ? "Data Saved Successfully" : "Data Sent for Review",
            type: "success",
          });
          navigate(`/dedicated/status-information?activeTab=${status === "PENDING" ? "pending" : "draft"}`);
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Latest News`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={NewsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${corporateHost}/api/airports-latest-news/${editData?.[0]?.id || dataById?.payload?.id}`
              : `${corporateHost}/api/create/airports-latest-news`,
            query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Malaysia Airports Academy"
      />
    </ContentWrapper>
  );
};
